export const TAKE_CARDS = 'take_cards';
export const DISCARD_CARD = 'discard_card';
export const SELECT_CARD_FROM_SEARCH_DISCARD = 'select_card_from_search_discard';
export const SELECT_CARD_FROM_END_TURN_DISCARD = 'select_card_from_end_turn_discard';
export const DOWN_CARDS = 'down_cards';
export const END_TURN = 'end_turn';
export const CARD_SPRING_SONG = 'card_spring_song';
export const CARD_AUTUMN_SONG = 'card_autumn_song__choose-player';
export const CARD_AUTUMN_SONG_EXECUTE = 'card_autumn_song__execute';
export const CARD_WINTER_SONG = 'card_winter_song';
export const CARD_GOBLIN_CREATURE = 'card_goblin_creature';
export const CARD_KOBOLD_CREATURE = 'card_kobold_creature';
export const CARD_TROLL_CREATURE = 'card_troll_creature';
export const NONE = 'none';